/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProductsIndex = 'route-products-index',
	uiPager = 'ui-pager',
	uiWishlistAction = 'ui-wishlist-action',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).products._index',
}

/* -------------------------------------------------------------------------------------------------
 * TEST_IDS
 * -----------------------------------------------------------------------------------------------*/

enum TEST_IDS {
	filterByTaxon = 'filter-by-taxon',
	filterByTaxonSelect = 'filter-by-taxon-select',
	searchResultsLabel = 'search-results-label',
	productList = 'product-list',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	page = 'page',
	itemsPerPage = 'itemsPerPage',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PRODUCTS_INDEX_I18NEXT,
	ROUTE_LOADER as PRODUCTS_INDEX_ROUTE_LOADER,
	TEST_IDS as PRODUCTS_INDEX_TEST_IDS,
	SEARCH_PARAMS as PRODUCTS_INDEX_SEARCH_PARAMS,
}
